import React from 'react';
import { PageSection } from '../Layout';
import { Button, ButtonGroup, ConfirmDialog, Message } from '../Core';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../Data/ReduxViewModels/Admin';

const RestartAdmin = () => {
  const dispatch = useDispatch();
  const restartQestnet = () => {
    dispatch(actions.restartQestnet());
  };

  const restarting = useSelector((state) => state.admin.qestnetRestart.restarting);
  const restarted = useSelector((state) => state.admin.qestnetRestart.restarted);
  const error = useSelector((state) => state.admin.qestnetRestart.error);

  return (
    <PageSection>
      <p>To restart the QESTNet service, click the button below.</p>
      {
        <Message warning>
          Restarting the QESTNet service will lead to some downtime. All active user sessions will be closed, any data
          entry in progress may be lost. Please ensure that any active users have completed their work prior to
          restarting.
        </Message>
      }
      {error && <Message error>Restart failed. {error}</Message>}
      {restarted && <Message success>QESTNet successfully restarted.</Message>}
      <ButtonGroup>
        <ConfirmDialog
          confirmTitle="QESTNet Restart"
          confirmText="Restarting QESTNet will close all open sessions. Are you sure you wish to continue?"
          confirmButtonText="Restart"
          confirmCancelButtonText="Cancel"
        >
          <Button primary onClick={restartQestnet} loading={restarting}>
            Restart QESTNet
          </Button>
        </ConfirmDialog>
      </ButtonGroup>
    </PageSection>
  );
};

export default RestartAdmin;
export { RestartAdmin };
